import React, { CSSProperties, FC, useMemo } from 'react';
import classNames from 'classnames';

import Tooltip from 'vibo-ui/Tooltip';

import { getProgressBarColor } from 'services/common/colorsHelper';

import { ProgressCircleProps } from './interfaces';

import useStyles from './style';

const ProgressCircle: FC<ProgressCircleProps> = ({ progress, className }) => {
  const classes = useStyles();

  const progressFraction = progress / 100;

  const progressColor = useMemo(() => getProgressBarColor(progress), [progress]);

  return (
    <Tooltip overlay={`Section progress ${progress}%`} type="primary" placement="top">
      <div className={classNames('progressCircle', classes.progressCircle, className)}>
        <svg
          style={
            {
              '--progress-color': progressColor,
              '--progress': progressFraction,
            } as CSSProperties
          }
          width="16"
          height="16"
          viewBox="0 0 16 16"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            className="fillEmpty"
            cx="8"
            cy="8"
            r="6.5"
            fill="none"
            stroke="var(--progress-back)"
            strokeWidth="3"
          />
          <circle
            cx="8"
            cy="8"
            r="6.5"
            fill="none"
            stroke="var(--progress-color)"
            strokeWidth="3"
            strokeLinecap="round"
            strokeDasharray="40.8"
            strokeDashoffset="calc(40.8 * (1 - var(--progress, 0)))"
            transform="rotate(-90 8 8)"
            style={{
              transition: 'stroke-dashoffset 0.7s ease',
            }}
          >
            <animate attributeName="strokeDashoffset" dur="0.7s" repeatCount="1" fill="freeze" />
          </circle>
        </svg>
      </div>
    </Tooltip>
  );
};

export default ProgressCircle;
